const isAuthenticated = () => localStorage.getItem('access_token') ? true : false;

export default isAuthenticated;